export default {
  serviceProvider: {},
  saml: {},
  accessLimitation: {},
  links: {},
};
